import { render } from "./EventScopeDialog.vue?vue&type=template&id=177e94fc&scoped=true"
import script from "./EventScopeDialog.vue?vue&type=script&lang=js"
export * from "./EventScopeDialog.vue?vue&type=script&lang=js"

import "./EventScopeDialog.vue?vue&type=style&index=0&id=177e94fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177e94fc"]])

export default __exports__